import React, { useState, useRef, useEffect } from 'react';
import { User, MapPin, ChevronDown, Phone } from 'lucide-react';

interface UserAvatarProps {
  userInfo: {
    name: string;
    email: string;
    center: string;
    phone?:string;
  };
}

const UserAvatar: React.FC<UserAvatarProps> = ({ userInfo }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  // Close popover when clicking outside
  // useEffect(() => {
  //   const handleClickOutside = (event: MouseEvent) => {
  //     // Check if click is outside both the popover and the button
  //     if (
  //       popoverRef.current && 
  //       !popoverRef.current.contains(event.target as Node) &&
  //       buttonRef.current &&
  //       !buttonRef.current.contains(event.target as Node)
  //     ) {
  //       setIsOpen(false);
  //     }
  //   };

  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const getRandomGradient = () => {
    const gradients = [
      'from-blue-500 to-purple-600',
      'from-purple-500 to-pink-600',
      'from-green-500 to-blue-600',
      'from-orange-500 to-red-600',
      'from-teal-500 to-cyan-600',
    ];
    return gradients[Math.floor(Math.random() * gradients.length)];
  };

  const gradient = getRandomGradient();

  return (
    <div className="relative">
      <button
    
    
        className="flex items-center cursor-text border gap-x-2 bg-white/10 backdrop-blur-sm border-white/20 rounded-full px-4 py-2 hover:bg-white/20 transition-all duration-300 group"
      >
        <div className={`w-10 h-10 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-lg transform group-hover:scale-105 transition-transform duration-200`}>
          {getInitials(userInfo.name)}
        </div>
        <div className="hidden md:flex">
          <div className="text-left">
            <p className='text-blue-600 font-semibold text-xs leading-none'>
              {userInfo.name}
            </p>
            <p className='text-gray-600 font-semibold text-sm mt-1 leading-4'>
              {userInfo.email}
            </p>
          </div>
        </div>
        <ChevronDown 
          className={`w-4 h-4 text-white/70 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
        />
      </button>

   
    </div>
  );
};

export default UserAvatar;